module.exports = __webpack_public_path__ + "img/nav-design-ringsets@2x.277b85a.webp";